import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { AppKeyTableActions } from '../appkey-table/appkey-table.models';
import { AppKeyLegals } from './appkey-legals.dialog.models';

@Component({
	selector: 'app-appkey-legals',
	templateUrl: './appkey-legals.dialog.html',
	styleUrls: ['./appkey-legals.dialog.scss']
})
export class AppKeyLegalsDialogComponent {
	public appKeyTableActions = AppKeyTableActions;

	constructor(
		@Inject(MAT_DIALOG_DATA) public dialogData: AppKeyLegals,
		private dialogRef: MatDialogRef<AppKeyLegalsDialogComponent>,
		private router: Router
	) {}

	public navigate(url: string, queryParams = {}) {
		this.dialogRef.close();
		this.router.navigate([url], { queryParams });
	}

	public openAction(action: AppKeyTableActions): void {
		this.dialogRef.close();
		this.dialogData.callback(action);
	}

	public close(): void {
		if (this.dialogData.callback) {
			this.dialogData.callback(null);
		}

		this.dialogRef.close();
	}
}
